/* v439 accessibility fixes for custom product selectors. */
(() => {
  const syncBuyBox = (box) => {
    const quantityChoices = box.querySelector('.rnt-qtys');
    const scentChoices = box.querySelector('.rnt-scents');

    if (quantityChoices) {
      quantityChoices.setAttribute('role', 'group');
      quantityChoices.setAttribute('aria-label', 'Choose quantity');
    }
    if (scentChoices) {
      scentChoices.setAttribute('role', 'group');
      scentChoices.setAttribute('aria-label', 'Choose scent');
    }

    box.querySelectorAll('[data-rnt-q], [data-rnt-variant]').forEach((choice) => {
      choice.setAttribute('aria-pressed', choice.classList.contains('is-on') ? 'true' : 'false');
    });
  };

  const syncAllBuyBoxes = () => document.querySelectorAll('[data-rnt-buybox]').forEach(syncBuyBox);

  document.addEventListener('DOMContentLoaded', syncAllBuyBoxes);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-rnt-q], [data-rnt-variant]')) {
      requestAnimationFrame(syncAllBuyBoxes);
    }
  });
})();
